import type { FC } from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type PatientTabSelectorProps = {
  choices: Array<{ label: string; value: string }>;
  selectedTab: string;
  setSelectedTab: React.Dispatch<React.SetStateAction<string>>;
};

const PatientTabSelector: FC<PatientTabSelectorProps> = ({
  choices,
  selectedTab,
  setSelectedTab,
}) => {
  return (
    <div className="flex gap-6 border-b border-gray-200 w-full">
      {choices.map((choice) => {
        return (
          <Button
            type="button"
            key={`tab-${choice.value.toLowerCase()}`}
            variant={"text"}
            size={"none"}
            className={cn([
              "justify-start pb-4 gap-[10px]",
              choice.value === selectedTab
                ? "text-brand-800 border-b-2 border-brand-600"
                : "text-gray-700",
            ])}
            onClick={() => setSelectedTab(choice.value)}
          >
            {choice.label}
          </Button>
        );
      })}
    </div>
  );
};

export default PatientTabSelector;
